module.exports = __webpack_public_path__ + "img/vino-tinto.9eff0c9b.jpg";